import React, {useState, useMemo, useEffect} from 'react';

import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
// import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

import {useFormStore} from '../../../Stores/form';

import './index.scss'

export default function Rate(props) {
    const {content, onChange, onBlur, disabled, field, isEditMode} = props;

    const {formVisibleErrors} = useFormStore();

    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const placeholder = useMemo(() => field.required ? `${field.placeholder} *` : field.placeholder, [field]);

    const className = useMemo(() => {
        let result = "Rate";
        result += isDisabled ? ' disabled' : ''
        result += showErrorText ? ' error' : ''
        return result;
    }, [isDisabled, showErrorText])

    return <div className={className}>
        <FormControl>
            <FormLabel>{placeholder}:</FormLabel>
        {/* <Typography component="legend">{field?.placeholder}:</Typography> */}
            <Rating
                value={content[field.id] || 0}
                emptyIcon={<StarIcon fontSize="inherit" />}
                precision={0.5}
                onChange={e => onChange({target: {value: Number(e.target.value)}})}
                onBlur={e => onBlur({target: {value: content[field.id]}})}
                size="large"
                readOnly={isDisabled}
            />
            {/* max={10} */}
        </FormControl>
        {showErrorText && <FormHelperText error={Boolean(showErrorText)}>{showErrorText}</FormHelperText>}
    </div>
}
